type IconProps = {
  style?: React.CSSProperties;
};

export const CalendarIcon = ({ style = {} }: IconProps) => {
  return (
    <img
      src="/assets/icons/calendar-icon.svg"
      alt="Calendar"
      style={{ marginRight: '8px', height: '1.4rem', ...style }}
    />
  );
};
